import React, { useState } from 'react'
import Button from './Buttons/login-button'
import SecondaryBtn from './Buttons/secondary-btn'
import Modal from './modal'
import CDButton from './cd-button'
import Loader from './loader'

function ConfirmationModal({ open, onConfirm, onClose, children }) {
  const [processing, setProcessing] = useState(false)

  const handleConfirm = () => {
    setProcessing(true)
    onConfirm && onConfirm().then(() => setProcessing(false))
  }

  return (
    <Modal open={open} onClose={onClose}>
      <div className='tw-w-96 tw-bg-white tw-p-3'>
        {children}
        <div className='tw-item-center tw-flex'>
          <button
            className='tw-ml-2 tw-px-[30px] tw-py-[7px] tw-gap-[10px] tw-rounded-[6px] tw-bg-electricGreen tw-text-white hover:tw-bg-black tw-text-regular hover:tw-cursor-pointer '
            onClick={handleConfirm}
          >
            {processing ? <Loader /> : 'Confirm'}
          </button>
          <SecondaryBtn onClick={onClose} label={'Cancel'} />
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
